import { readUrlParam } from "./urlParams.js";

// Opening something in the detail panel FULL SCREEN, the reverse of
// exitDetailFullScreen: the navigation runs first and the expand goes out two
// frames later, once the new content has mounted in the panel, so the panel
// grows with what the reader came to read rather than with what it replaces.
// It is the command the panel's own expand control issues, so it is the same
// FLIP, and ContentShell ignores it when the detail panel is already the
// expanded column.
//
// A shell that is not mounted yet (the navigation switches mode) never hears
// the command; the navigation's ?xcol=detail (applyTraceNavParams' `expand`)
// covers it, since ContentShell replays ?xcol when it mounts. When another
// column already holds the screen (a pinned view), the panel stays in place.
//
// The panel's switch from the chat to the context (ScopedPage) collapses the
// column, so an expand the chat's canvas made does not carry over to what the
// panel shows next. The navigation causes that switch, and a render later its
// collapse would undo this expand or race it; so the request is also left for
// the switch to take (takeDetailExpandRequest), which then expands instead.
const REQUEST_MS = 3000;
let requestedAt = 0;

export function enterDetailFullScreen(navigate, { now = Date.now } = {}) {
    const held = readUrlParam("xcol");
    if (held && held !== "detail") {
        navigate();
        return;
    }
    requestedAt = now();
    navigate();
    requestAnimationFrame(() => requestAnimationFrame(() => {
        window.dispatchEvent(new CustomEvent("origin-column-expand", {
            detail: { columnId: "detail", mode: "expand" },
        }));
    }));
}

// Whether a navigation just asked for the detail panel full screen. Taking the
// request clears it, and it lapses on its own, so a later switch the reader
// makes collapses as before.
export function takeDetailExpandRequest(now = Date.now()) {
    const pending = requestedAt > 0 && now - requestedAt <= REQUEST_MS;
    requestedAt = 0;
    return pending;
}
